const routes = [
  {
    path: '/admin',
    component: () => import('layouts/AdminLayout.vue'),
    children: [
      {
        path: '/',
        component: () => import('pages/Index.vue')
      },
      {
        path: '/admin/surveys',
        component: () => import('pages/surveys/SurveysAdmin.vue')
      },
      {
        path: '/admin/markets',
        component: () => import('pages/Markets.vue')
      },
      {
        path: '/admin/market/:market',
        component: () => import('pages/Market.vue'),
        name: 'market',
        props: true
      },
      {
        path: '/admin/reports',
        component: () => import('pages/ReportsAdmin.vue')
      },
      {
        path: '/admin/reports/create',
        component: () => import('pages/ReportCreation.vue')
      },
      {
        path: '/admin/report/:id',
        component: () => import('pages/Report.vue'),
        name: 'id',
        props: true
      },
      {
        path: '/admin/api',
        component: () => import('pages/user/API.vue')
      },
      {
        path: '/admin/destinations',
        component: () => import('pages/user/Destinations.vue')
      },
      {
        path: '/admin/destination/:country',
        component: () => import('pages/user/Destination.vue'),
        name: 'country',
        props: true
      },
      {
        path: '/admin/website',
        component: () => import('pages/ResearchForm/ResearchForm.vue')
      },
      {
        path: '/admin/users',
        component: () => import('pages/UsersAdmin.vue')
      },
      {
        path: '/admin/analytics',
        component: () => import('pages/Analytics.vue')
      },
      {
        path: '/admin/counter',
        component: () => import('pages/Counter.vue')
      },
      {
        path: '/admin/invoices',
        component: () => import('pages/AdminInvoices.vue')
      },
      { path: '/admin/settings', component: () => import('pages/Settings.vue') }
    ]
  },
  {
    path: '/validate',
    component: () => import('layouts/ValidateLayout.vue'),
    children: [
      {
        path: 'account',
        name: 'ValidateAccount',
        component: () => import('pages/ValidateAccount.vue')
      }
    ]
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '/',
        redirect: '/research'
      },
      {
        path: '/buyer-personas',
        component: () => import('pages/BuyerPersonas.vue'),
        name: 'Buyer Personas'
      },
      {
        path: '/research',
        component: () => import('pages/ResearchForm/ResearchForm.vue'),
        name: 'ResearchForm'
      },
      {
        path: '/research/:section',
        component: () => import('pages/Research/Research.vue'),
        name: 'section',
        props: true,
        meta: { requiresSearch: true }
      },
      {
        path: '/favorites',
        component: () => import('pages/user/Favorites.vue'),
        name: 'Favorites'
      },
      {
        path: '/report/:id',
        component: () => import('pages/Report.vue'),
        name: 'Repor',
        props: true
      },
      {
        path: '/destinations',
        component: () => import('pages/user/Destinations.vue'),
        name: 'Destinations'
      },
      {
        path: '/destinations/:country',
        component: () => import('pages/user/Destination.vue'),
        name: 'Destination',
        props: true
      },
      {
        path: '/help',
        component: () => import('pages/user/Help.vue'),
        name: 'Help'
      },
      {
        path: '/api',
        component: () => import('pages/user/API.vue'),
        name: 'API'
      }
    ]
  },
  {
    path: '/user',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '/',
        component: () => import('pages/user/User.vue'),
        name: 'User Settings'
      },
      {
        path: '/user/upgrade',
        component: () => import('pages/user/Upgrade.vue'),
        name: 'Upgrade'
      },
      {
        path: '/user/invoice',
        component: () => import('pages/SubscriptionInvoice.vue'),
        name: 'Subscription Invoice',
        props: true
      },
      {
        path: '/user/new',
        component: () => import('pages/user/UserNew.vue'),
        name: 'User New'
      }
    ]
  },
  {
    path: '/users',
    component: () => import('layouts/MainLayout.vue'),

    children: [
      {
        path: '/users/invoice/:id',
        component: () => import('pages/SubscriptionInvoiceAdmin.vue'),
        name: 'Admin Subscription Invoice',
        props: true
      }
    ]
  },
  {
    path: '/reports',
    component: () => import('layouts/MainLayout.vue'),

    children: [
      {
        path: '/',
        component: () => import('pages/Reports.vue'),
        name: 'Reports'
      },
      {
        path: '/reports/create/',
        component: () => import('pages/ReportCreation.vue'),
        name: 'Create Report',
        props: true
      },
      {
        path: '/reports/create/:type/:market',
        component: () => import('pages/ReportCreation.vue'),
        name: 'Create Report Market',
        props: true
      },
      {
        path: '/reports/payment/:id',
        component: () => import('pages/ReportPayment.vue'),
        name: 'Report Payment',
        props: true
      },
      {
        path: '/reports/doc/:id',
        component: () => import('pages/Report.vue'),
        name: 'Report',
        props: true
      },
      {
        path: '/reports/doc/:id/:page',
        component: () => import('pages/Report.vue'),
        name: 'ReportPage',
        props: true
      },
      {
        path: '/reports/invoice/:id',
        component: () => import('pages/ReportInvoice.vue'),
        name: 'Report Invoice',
        props: true
      },
      {
        path: '/reports/print/:id',
        component: () => import('pages/ReportPrint.vue'),
        name: 'Report BAR Print',
        props: true
      },
      {
        path: '/reports/printbac/:id',
        component: () => import('pages/ReportPrintBAC.vue'),
        name: 'Report BAC Print',
        props: true
      }
    ]
  },
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      { path: '/', component: () => import('pages/user/Login.vue') },
      {
        path: '/login/register',
        component: () => import('pages/user/Register.vue'),
        name: 'Register'
      },
      {
        path: '/login/reset',
        component: () => import('pages/user/Reset.vue'),
        name: 'Reset'
      },
      {
        path: '/login/report/:type/:market',
        component: () => import('pages/user/RegisterReport.vue'),
        name: 'RegisterReport',
        props: true
      },
      {
        path: '/login/events/',
        component: () => import('pages/user/RegisterEvent.vue'),
        name: 'RegisterEvent',
        props: true
      }
    ]
  },
  {
    path: '/thankyou',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '/', component: () => import('pages/user/Thankyou.vue') },
      {
        path: '/thankyou/:product',
        component: () => import('pages/user/Thankyou.vue'),
        name: 'Thank You',
        props: true
      }
    ]
  },
  {
    path: '/surveys',
    component: () => import('layouts/SurveyLayout.vue'),
    children: [
      {
        path: '/',
        component: () => import('pages/surveys/Surveys.vue'),
        name: 'Surveys'
      },
      {
        path: '/survey/:name/:language',
        component: () => import('pages/surveys/Survey.vue'),
        name: 'NewSurvey',
        props: true
      },
      {
        path: '/survey/:name/:language/:id',
        component: () => import('pages/surveys/Survey.vue'),
        name: 'Survey',
        props: true
      }
    ]
  }
];

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  });
}

export default routes;
